package org.multiplatform.kotfolio.pages.kmm

import androidx.compose.runtime.*
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.core.Page

@Page("/kmm/qr_scanner")
@Composable
fun QRScannerKMMPage() {
    BlogLayout(
        PageProperties(
            "QR Scanner",
            ""
        ),
        BlogProperties("Kotlin Multiplatform", "QR Scanner")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            KotlinCode(
                code = """
                    @Composable
                    fun ScanProfileQrScreen() {
                        Scaffold(
                            modifier = Modifier
                                .background(MaterialTheme.colorScheme.background)
                                .fillMaxSize(),
                            topBar = {
                               
                            },
                        ) {
                            Column(
                                modifier = Modifier
                                    .fillMaxSize()
                                    .padding(horizontal = 36.dp),
                                verticalArrangement = Arrangement.Center,
                                horizontalAlignment = Alignment.CenterHorizontally,
                            ) {
                                Box(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .aspectRatio(ratio = 1f)
                                ) {
                                    QrScanner(
                                        modifier = Modifier
                                            .fillMaxSize()
                                            .padding(4.dp)
                                            .clipToBounds(),
                                        flashlightOn = false,
                                        cameraLens = CameraLens.Back,
                                        openImagePicker = false,
                                        imagePickerHandler = {},
                                        onFailure = {},
                                        onCompletion = { scannedText ->
                                         
                                        },
                                        customOverlay = {
                                            drawContent()
                                        }
                                    )
                                    Image(
                                        modifier = Modifier
                                            .fillMaxSize(),
                                        painter = painterResource(Res.drawable.scanner_frame),
                                        contentDescription = null,
                                    )
                                }
                            }
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    Column(modifier = Modifier.fillMaxWidth()) {
                        val textRegular = VintrlessExtendedTheme.colors.textRegular
                        
                        Image(
                            modifier = Modifier
                                .align(Alignment.CenterHorizontally)
                                .size(200.dp),
                            painter = rememberQrKitPainter(
                                data = state.payload.profileUrl,
                                qrOptions = {
                                    shapes = QrKitShapes(
                                        ballShape = getSelectedQrBall(QrBallType.CircleQrBall()),
                                        darkPixelShape = getSelectedPixel(QrPixelType.CirclePixel()),
                                        frameShape = getSelectedFrameShape(QrFrameType.CircleFrame()),
                                        codeShape = getSelectedPattern(PatternType.SquarePattern)
                                    )
                                    colors = QrKitColors(
                                        darkBrush = QrKitBrush.solidBrush(textRegular)
                                    )
                                }
                            ),
                            contentDescription = "Profile url QR"
                        )
                    }
                    """.trimIndent()
            )
        }
    }
}
